import React from 'react'
import ExpenseReport from '../expenseReport/ExpenseReport'
import ItineraryHPMetaManager from './seo/ItineraryHPMetaManager'

export const renderPage = () => (
  <>
    <ItineraryHPMetaManager />
    <ExpenseReport />
  </>
)
